/**
 * Device-local household Money view. Not a login and not an access restriction.
 */

const KEY = "tt-money-household";

export type StoredHouseholdView = string;

export function readHouseholdView(): StoredHouseholdView {
  try {
    return localStorage.getItem(KEY) || "all";
  } catch {
    return "all";
  }
}

export function writeHouseholdView(id: StoredHouseholdView) {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* quota */
  }
}

const PREVIEW_KEY = "tt-owner-preview-now";

export function readDevicePreviewNow(): string | null {
  try {
    return localStorage.getItem(PREVIEW_KEY);
  } catch {
    return null;
  }
}

export function writeDevicePreviewNow(value: string | null) {
  try {
    if (!value) localStorage.removeItem(PREVIEW_KEY);
    else localStorage.setItem(PREVIEW_KEY, value);
  } catch {
    /* quota */
  }
}
